import { AppText } from "@/shared/Components";
import { AppHighlighter } from "@/shared/Components/AppHighlighter";
import type { SearchResponseItemField } from "@/services/api/entities/search";
import { cleanValue, pascalCaseToString } from "../utils";
import { FIELD_HEIGHT, NOTE_HEIHT } from "../../constants";
import styles from "./styles.module.scss";

type SearchCardFieldProps = {
  field: SearchResponseItemField;
  textQuery: string;
  type?: "note" | "person";
};

export const SearchCardField = (props: SearchCardFieldProps) => {
  return (
    <div className={styles.container}>
      <AppText weight="medium" size="sm" type="secondary" className={styles.title}>
        {pascalCaseToString(props.field.name)}
      </AppText>
      <AppText
        style={{ height: props.type === "note" ? NOTE_HEIHT : FIELD_HEIGHT }}
        className={styles.value}
      >
        <AppHighlighter
          searchWords={[props.textQuery]}
          textToHighlight={cleanValue(props.field.value)}
        />
      </AppText>
    </div>
  );
};
